const speedDial = {
  quickCreate: "יצירה מהירה",
  aiAssistant: "עוזר AI",
  search: "חיפוש",
  newNote: "פתק חדש",
  timer: "טיימר",
  editMode: "מצב עריכה",
  doneEditing: "סיום עריכה",
  pickShortcut: "בחר קיצור דרך",
  searchShortcuts: "חיפוש...",
  pages: "לשוניות",
  widgets: "וויג׳טים",
  entities: "ישויות",
  longPressToEdit: "לחיצה ארוכה לעריכה",
  emptySlot: "ריק",
  removeSlot: "הסר",
} as const;
export default speedDial;
